import { FC } from 'react';

import { dateWithDayOfWeekWithTime, tijdstipDatum, timeWithDayOfWeekWithTime } from '@/utils/dateUtils';

import styles from './DefectTimeLabel.module.css';
type DefectTimeLabelProps = {
  label?: string;
  dateTime: string | null | undefined;
  variant: 'time' | 'dayTime' | 'dayDateTime';
};

const DefectTimeLabel: FC<DefectTimeLabelProps> = ({ dateTime, label = undefined, variant = 'dayTime' }) => {
  return (
    <div className={styles.timeLabel}>
      {label}
      {variant === 'time' && tijdstipDatum(dateTime)}
      {variant === 'dayTime' && timeWithDayOfWeekWithTime(dateTime)}
      {variant === 'dayDateTime' && dateWithDayOfWeekWithTime(dateTime)}
    </div>
  );
};
export default DefectTimeLabel;
